module.exports = __webpack_public_path__ + "public/images/header-slide-6.27418be0c36f928c1ad1bf9ea40e7945.jpg";